<template lang="pug">
  div.h-screen.flex.justify-center.items-center(class="sm:items-start sm:pt-40")
    img.absolute.left-0(class="lg:hidden" alt="Move illustration 1" src="../assets/images/move1.png")
    img.absolute.right-0(class="lg:hidden" alt="Move illustration 2" src="../assets/images/move2.png")

    p.absolute.top-0.right-0.mr-8.mt-8.z-10(class="sm:w-full sm:mr-0 sm:text-center sm:mt-24" v-if="type === 'signUp'") Already got an account? #[a(@click="$emit('changeState', 'signIn')") Sign in]
    p.absolute.top-0.right-0.mr-8.mt-8.z-10(class="sm:w-full sm:mr-0 sm:text-center sm:mt-24" v-else) Don’t have an account? #[a(@click="$emit('changeState', 'signUp')") Create one]

    div.text-center.max-w-sm(class="sm:pb-20")
      div(v-if="header")
        h1.text-5xl {{header}}
        p.text-xl.text-gray-6.mb-6 {{subheader}}
      div(v-else)
        div(v-if="type === 'signUp'")
          h1.text-5xl Let’s get moving!
          p.text-xl.text-gray-6.mb-6 Ready to build a record breaking team?
        div(v-else)
          h1.text-5xl Welcome back!

      transition(name="collapse")
        .w-full.h-32.mt-4(v-if="!name && !password")
          button.main.justify-between.p-4.w-full(@click="withGoogle")
            .bg-indigo-7.rounded-tl-lg.rounded-bl-lg.-m-4.p-4.w-16.flex.justify-center.items-center
              eva-icon.icon.text-indigo-2(name="google")
            span.flex-grow Sign #[span(v-if="type == 'signIn'") in] #[span(v-else) up] with Google
          
          .flex.items-center.mt-6
            .h-px.flex-1.bg-gray-3.mt-1
            span.px-2.text-gray-5 or
            .h-px.flex-1.bg-gray-3.mt-1

      form.w-full(@submit.prevent="validate")
        div(v-if="type === 'signUp'")
          label Full name
          input(type="text" v-model="name" :class="{error: nameError}")
          transition(name="collapse")
            p.error-text(v-if="nameError") {{ nameError }}
        
        div.mt-4
          label Work email
          input(v-model="email" :disabled="disableEmail" :class="{error: emailError}")
          transition(name="collapse")
            p.error-text(v-if="emailError") {{ emailError }}
        
        div.mt-4
          label Password
          input(v-if="type === 'signUp'" placeholder="Make it a long & funny phrase" type="password" v-model="password" :class="{error: passwordError}")
          input(v-else type="password" v-model="password" :class="{error: passwordError}")
          transition(name="collapse")
            p.error-text(v-if="passwordError") {{ passwordError }}

        button.mt-6.w-full.p-4(type="submit" :class="{main: name || password}") 
          span(v-if="type === 'signUp'") Create account
          span(v-else) Sign in
        
        .mt-4
          router-link.text-gray-7(to="/password" v-if="type === 'signIn'") Forgot password?
        
        p.text-sm.font-normal.text-left.text-gray-6.w-full.mt-2(v-if="type === 'signUp'") Creating your account means you’re okay with our #[a(href="https://wangll.co/privacy" target="_blank") Privacy Policy] and #[a(href="https://wangll.co/terms" target="_blank") Terms of Service]
        
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Auth",
  data() {
    return {
      name: "",
      nameError: "",
      email: "",
      emailError: "",
      disableEmail: false,
      password: "",
      passwordError: ""
    };
  },
  created() {
    const linkEmail = this.$route.query.email;
    if (!linkEmail) return;
    else {
      this.email = linkEmail;
      this.disableEmail = true;
    }
  },
  props: ["header", "subheader", "type", "action"],
  computed: { ...mapGetters(["company", "objectives", "keyResults"]) },
  methods: {
    ...mapActions(["signInWithGoogle", "test", "signUpForm"]),
    async withGoogle() {
      await this.$store.dispatch("signInWithGoogle");
      this.$emit("done");
    },
    async validate() {
      if (!this.name && this.type === "signUp")
        this.nameError = "You need a name";
      else this.nameError = "";

      // validate email
      if (!this.email) this.emailError = "You need an email address";
      else {
        const lintedEmail = await this.$store.dispatch("lintEmail", this.email);
        const isEmail = await this.$store.dispatch("isEmail", lintedEmail);

        if (!isEmail) this.emailError = "That’s not a proper email address";
        else {
          this.email = lintedEmail;
          this.emailError = "";
        }
      }

      if (this.password.length < 6)
        this.passwordError = "C’mon, at least 6 characters please";
      else this.passwordError = "";

      // check if there are any errors before proceeding
      if (this.nameError || this.emailError || this.passwordError) {
        return;
      }
      // sign up if no errors
      else {
        const credentials = {
          email: this.email,
          password: this.password,
          displayName: this.name
        };
        if (this.type === "signUp") {
          this.$store
            .dispatch("signUpWithPassword", credentials)
            .then(() => this.$emit("done"));
        } else {
          this.$store
            .dispatch("signInWithPassword", credentials)
            .then(() => this.$emit("done"));
        }
      }
    }
  }
};
</script>
<style lang="sass" scoped>
img
  height: 400px
</style>
